// Settings.jsx
// Tenant-wide on/off options. Saved per key on the server (app_settings, V090).
import React, { useState } from "react";
import {
  Alert,
  Box,
  CircularProgress,
  Container,
  FormControlLabel,
  Paper,
  Switch,
  Typography,
} from "@mui/material";
import useAppSettings from "./useAppSettings";

const OPTIONS = [
  {
    key: "itemMasterPriceDecimals",
    label: "Allow decimals in price on Item Creation",
    help: "On: prices like 42.50 can be entered. Off: whole numbers only. Items already priced with decimals keep their price.",
  },
  {
    key: "itemPriceUpdatePriceDecimals",
    label: "Allow decimals in price on Item Price Update",
    help: "On: prices like 42.50 can be entered. Off: whole numbers only.",
  },
];

const Settings = () => {
  const { settings, loaded, save } = useAppSettings();
  const [savingKey, setSavingKey] = useState(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const toggle = async (key, value) => {
    setSavingKey(key);
    setError("");
    setSuccess("");
    try {
      await save({ [key]: value });
      setSuccess("Saved.");
    } catch (e) {
      setError(e.message);
    } finally {
      setSavingKey(null);
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: 3 }}>
      <Typography variant="h4" gutterBottom>
        Settings
      </Typography>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess("")}>{success}</Alert>}

      <Paper sx={{ p: { xs: 2, sm: 3 } }}>
        <Typography variant="h6" gutterBottom>
          Item price
        </Typography>
        {!loaded ? (
          <CircularProgress size={24} />
        ) : (
          OPTIONS.map((o) => (
            <Box key={o.key} sx={{ py: 1.5, borderTop: 1, borderColor: "divider", "&:first-of-type": { borderTop: 0 } }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={!!settings[o.key]}
                    disabled={savingKey !== null}
                    onChange={(e) => toggle(o.key, e.target.checked)}
                  />
                }
                label={o.label}
              />
              {savingKey === o.key && <CircularProgress size={16} sx={{ ml: 1, verticalAlign: "middle" }} />}
              <Typography variant="body2" color="text.secondary" sx={{ ml: { xs: 0, sm: 6 } }}>
                {o.help}
              </Typography>
            </Box>
          ))
        )}
      </Paper>
    </Container>
  );
};

export default Settings;
